import REST_URLS from "../RestUrls.constants";
import RestService from "../RestService";

const base = REST_URLS.EXAM.baseUrl;
const endpoints = REST_URLS.EXAM.endpoints;

export default {
  createExam(data) {
    let url = base + endpoints.createExam;
    return RestService.postRequest(url, data);
  },

  updateExam(data) {
    let url = base + endpoints.updateExam;
    return RestService.putRequest(url, data);
  },

  deleteExam(data) {
    let url = base + endpoints.deleteExam;
    return RestService.deleteRequest(url, { data: data });
  },

  setScoreTable(data) {
    let url = base + endpoints.setScoreTable;
    return RestService.postRequest(url, data);
  },

  submitExam(data) {
    let url = base + endpoints.submitExam;
    return RestService.postRequest(url, data);
  },

  deleteScoreReport(data) {
    let url = base + endpoints.deleteScoreReport;
    return RestService.deleteRequest(url, { data: data });
  }
};
